import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppConfig } from 'src/app/common/app-config/app-config.interface';
import { AppConfigService } from 'src/app/common/app-config/app-config.service';
import { AccordionItemComponent } from 'src/app/components/accordion/accordion-item.component';
import { AccordionComponent } from 'src/app/components/accordion/accordion.component';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-profile-sidebar',
  templateUrl: `./${environment.pageFolder}/profile-sidebar.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/profile-sidebar.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [RouterModule, TranslateModule, CommonModule, AccordionComponent, AccordionItemComponent]
})
export class ProfileSidebarComponent {
  userProfileLink = "/user-profile";
  updateProfileLink = "/update-profile";
  @Input() activePage!: string;
  activePageFormatted!: string;
  appConfig: AppConfig;
  transferTicketIsActive: boolean = false;
  transferTicketLoading: boolean = true;
  
  constructor(    
    private appConfigService: AppConfigService,
    private translate: TranslateService,
    private profileService: ProfileService
  ) {
    this.appConfig = appConfigService.getConfig();
  }

  ngOnInit() {
    const pageMap: { [key: string]: string } = {
      'user-profile': 'PROFILE.MY_TICKETS',
      'update-profile': 'PROFILE.EDIT_PROFILE',
      'membership-profile': 'PROFILE.MY_MEMBERSHIP',
      'group-tickets-profile': 'PROFILE.GROUP_TICKETS',
      'transfer-tickets': 'PROFILE.GIVE_TICKETS',
      'my-cards': 'PROFILE.MY_CARDS'
    };
  
    const translationKey = pageMap[this.activePage];
  
    if (translationKey) {
      this.translate.get(translationKey).subscribe((res: string) => {
        this.activePageFormatted = res;
      });
    }

    this.profileService.getSubsribersTickets(true).subscribe({
      next: (data) => {
        const response: any = data;
        const memberships = response.data.others;

        this.transferTicketIsActive = memberships.some((membership: any) => {
          return membership.ticketDelegation;
        });

        this.transferTicketLoading = false;
      },
    });
  }
}
